























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TestPassResult as ITestPassResult } from "@/api/models/test-pass-result";
import { User as IUser } from "@/api/models/user";
import {
  getCurrentCompanyId,
  getCurrentEmployee,
  isRoot
} from "@/plugins/roles";
import api from "@/getinfo-api";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { isAllowEditDates } from "@/plugins/modules-detect";
import TextField from "@/components/form/CustomPage/textField.vue";

interface Form {
  startedAt: Date;
  passedAt: Date;
}
@Component({
  components: { TextField, CustomButton, CustomDatepicker }
})
export default class TestPassResult extends Vue {
  @Prop({ required: true }) testResult!: ITestPassResult;
  testPassOwner!: IUser;
  isShowStartedAt: boolean = false;
  isShowPassedAt: boolean = false;
  showEditIcon: boolean = false;
  form: Form = {
    startedAt: this.testResult.startedAt,
    passedAt: this.testResult.passedAt
  };

  get currentCompany() {
    return getCurrentCompanyId();
  }

  data() {
    return {
      testPassOwner: undefined
    };
  }

  get testStatusFormatted() {
    return this.testResult.success === false
      ? this.$tc(this.$translate.TestFailed)
      : this.$tc(this.$translate.TestSuccessfullyPassed);
  }

  get rightQuestionsCount() {
    return this.testResult.questions.filter(element => {
      return element.isRight;
    }).length;
  }

  get notRightQuestionsCount() {
    return this.testResult.questions.filter(element => {
      return !element.isRight;
    }).length;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  get root() {
    return isRoot();
  }

  get employee() {
    return getCurrentEmployee();
  }

  currentUserCanEdit() {
    if ((this.root || this.employee) && isAllowEditDates) {
      this.showEditIcon = true;
    }
  }

  goToPrint() {
    window.print();
  }

  saveStartedAt() {
    api.TestPassApi.editStartedAt(this.form.startedAt, this.testResult.id)
      .then(() => {
        this.isShowPassedAt = false;
        this.isShowStartedAt = false;
        this.$emit("changeDates");
        this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  savePassedAt() {
    api.TestPassApi.editPassedAt(this.form.passedAt, this.testResult.id)
      .then(() => {
        this.isShowPassedAt = false;
        this.isShowStartedAt = false;
        this.$emit("changeDates");
        this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
  getListener() {
    if (this.root || this.employee) {
      api.UsersApi.get(this.testResult.ownerId).then((res: { data: IUser }) => {
        this.testPassOwner = res.data;
      });
    }
  }

  getClassForAnswer(answer: any) {
    let classes = [];
    if (answer.userAnswer && answer.value) {
      classes.push("userRight");
    }
    if (
      (answer.userAnswer && !answer.value) ||
      (!answer.userAnswer && answer.value)
    ) {
      classes.push("userNotRight");
    }
    return classes;
  }

  getClassForIcon(answer: any) {
    let classes = [];
    if (answer.userAnswer && answer.value) {
      classes.push("fa fa-check");
    }

    if (answer.userAnswer && !answer.value) {
      classes.push("fa fa-times");
    }

    if (!answer.userAnswer && answer.value) {
      classes.push("fa fa-exclamation-triangle");
    }
    return classes;
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get userAnswerCount() {
    let count = this.testResult.questions.filter(element => {
      return element.passedAt;
    });
    return count.length;
  }

  created() {
    this.getListener();
    this.currentUserCanEdit();
  }
}
